import { Product } from '@features/add-to-cart-page/typings/Product';

export const shouldKeepPromoLabelSpace = (products: Product[]): boolean => {
  return products.some(product => product.promoIcon && product.promoIcon.displayText !== null);
};
